import React from 'react';
import { Link } from 'react-router-dom';
import { fullTeam } from '../data/team';
import { useInView } from '../hooks';

const SocialIcon = ({ platform }) => {
  const icons = {
    twitter:   <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor" />,
    linkedin:  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z M4 6a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" />,
    github:    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" fill="currentColor" />,
    instagram: <><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069z" fill="currentColor"/><circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1.5" fill="currentColor"/></>,
    spotify:   <path d="M12 2a10 10 0 100 20A10 10 0 0012 2zm4.584 14.418a.622.622 0 01-.858.207c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 01-.277-1.215c3.808-.87 7.076-.496 9.713 1.115a.622.622 0 01.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.785-2.131-9.965-1.166a.78.78 0 01-.972-.519.782.782 0 01.519-.972c3.632-1.102 8.147-.568 11.234 1.328a.78.78 0 01.256 1.072zm.105-2.835C14.69 8.95 9.375 8.775 6.297 9.71a.937.937 0 11-.543-1.794c3.514-1.066 9.354-.859 13.038 1.241a.937.937 0 01-.88 1.704z" fill="currentColor" />,
    discord:   <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z" fill="currentColor" />,
  };
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4">
      {icons[platform]}
    </svg>
  );
};

const leadership = fullTeam.slice(0, 2);
const supporting = fullTeam.slice(2);

const TeamPage = () => {
  const [heroRef, heroInView] = useInView(0.1);
  const [leadRef, leadInView] = useInView(0.1);
  const [teamRef, teamInView] = useInView(0.05);

  return (
    <div className="min-h-screen pt-24">
      {/* Hero */}
      <section className="py-16 md:py-24 relative african-pattern">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black" />
        <div
          ref={heroRef}
          className={`relative z-10 max-w-7xl mx-auto px-6 text-center transition-all duration-1000 ${heroInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <p className="section-subtitle text-secondary-400">THE DREAMERS</p>
          <h1 className="section-title mb-6">
            MEET THE <span className="text-gradient">TEAM</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            A passionate crew of creators, coders, and storytellers united by one mission:
            putting Africa on the global gaming map.
          </p>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="section-subtitle text-primary-500">FOUNDERS & DIRECTORS</p>
            <h2 className="section-title">
              STUDIO <span className="text-gradient">LEADERSHIP</span>
            </h2>
          </div>

          <div
            ref={leadRef}
            className={`grid md:grid-cols-2 gap-8 max-w-4xl mx-auto transition-all duration-1000 ${leadInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            {leadership.map((member) => (
              <div
                key={member.id}
                className="relative overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-b from-white/8 to-white/3 p-1 group"
              >
                {/* Gradient border glow on hover */}
                <div className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ background: 'linear-gradient(135deg, rgba(255,107,53,0.3) 0%, rgba(0,212,170,0.3) 100%)' }} />

                <div className="relative rounded-[22px] overflow-hidden bg-black p-8">
                  {/* Decorative bg glow */}
                  <div className={`absolute top-0 right-0 w-48 h-48 rounded-full blur-3xl opacity-20 bg-gradient-to-br ${member.color}`} />

                  <div className="relative z-10">
                    {/* Avatar */}
                    <div className={`w-24 h-24 rounded-2xl bg-gradient-to-br ${member.color} flex items-center justify-center text-5xl mb-6 shadow-lg`}>
                      {member.avatar}
                    </div>

                    {/* Name & role */}
                    <h2 className="text-2xl font-bold text-white mb-1">{member.name}</h2>
                    <p className="text-secondary-400 font-gaming text-sm tracking-wider mb-5">{member.role}</p>

                    {/* Bio */}
                    <p className="text-gray-400 text-sm leading-relaxed mb-6">{member.bio}</p>

                    {/* Role badges */}
                    <div className="flex flex-wrap gap-2 mb-6">
                      {member.role.split(' & ').map(r => (
                        <span key={r} className="px-3 py-1 rounded-full text-xs font-medium bg-white/8 border border-white/15 text-gray-300">
                          {r}
                        </span>
                      ))}
                    </div>

                    {/* Social links */}
                    {member.social && (
                      <div className="flex gap-3">
                        {Object.entries(member.social).map(([platform, url]) => (
                          <a
                            key={platform}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-9 h-9 rounded-lg bg-white/8 border border-white/15 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/15 transition-all"
                          >
                            <SocialIcon platform={platform} />
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Supporting team */}
      {supporting.length > 0 && (
        <section className="py-24 bg-gradient-to-b from-transparent via-white/3 to-transparent">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <p className="section-subtitle text-secondary-400">THE FULL CREW</p>
              <h2 className="section-title">
                STUDIO <span className="text-gradient">TEAM</span>
              </h2>
            </div>

            <div
              ref={teamRef}
              className={`grid sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-1000 ${teamRef ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              {supporting.map((member) => (
                <div
                  key={member.id}
                  className="card-hover text-center p-7 bg-white/5 rounded-3xl border border-white/10 group"
                >
                  <div className={`w-18 h-18 w-[72px] h-[72px] mx-auto mb-4 rounded-2xl bg-gradient-to-br ${member.color} flex items-center justify-center text-4xl group-hover:scale-110 transition-transform shadow-lg`}>
                    {member.avatar}
                  </div>
                  <h3 className="font-bold text-lg mb-1 group-hover:text-primary-400 transition-colors">
                    {member.name}
                  </h3>
                  <p className="text-secondary-400 text-sm mb-3 font-gaming tracking-wide text-xs">
                    {member.role}
                  </p>
                  <p className="text-gray-500 text-xs leading-relaxed line-clamp-3">{member.bio}</p>
                  {member.social && (
                    <div className="flex justify-center gap-2 mt-4">
                      {Object.entries(member.social).map(([platform, url]) => (
                        <a
                          key={platform}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-7 h-7 rounded-md bg-white/8 flex items-center justify-center text-gray-500 hover:text-white hover:bg-white/15 transition-all"
                        >
                          <SocialIcon platform={platform} />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Culture section */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="section-subtitle text-primary-500">LIFE AT RIVEN BYTE</p>
            <h2 className="section-title">
              OUR <span className="text-gradient">CULTURE</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: '🌍', title: 'African First', desc: 'We put African culture, stories, and talent at the heart of everything we do.' },
              { icon: '🚀', title: 'Ship & Iterate', desc: 'Move fast, learn from players, improve constantly. No game is ever truly finished.' },
              { icon: '🤝', title: 'Open Doors', desc: 'Flat structure, direct communication. Every voice matters regardless of title.' },
              { icon: '🎓', title: 'Learn Always', desc: 'Budget for courses, conferences, and experimentation. Growth is a team sport.' },
              { icon: '⚖️', title: 'Balance Matters', desc: 'We build sustainable schedules. Crunch is a design failure, not a badge of honour.' },
              { icon: '🌱', title: 'Give Back', desc: 'Monthly hackathons, mentorship for local devs, and open-source contributions.' },
            ].map((item) => (
              <div key={item.title} className="card-hover p-7 bg-white/5 rounded-3xl border border-white/10">
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join us CTA */}
      <section className="py-24 bg-gradient-to-r from-primary-500/10 via-transparent to-secondary-400/10">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="text-6xl mb-6 animate-float inline-block">🎮</div>
          <h2 className="font-gaming text-3xl md:text-4xl font-bold mb-4">
            WANT TO <span className="text-gradient">JOIN US?</span>
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            We're always looking for passionate people who share our vision. Check open roles
            or just introduce yourself.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary inline-block text-center">View Open Roles →</Link>
            <Link to="/contact" className="btn-secondary inline-block text-center">Say Hello</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;
